import { useState } from 'react'

/**
 * Custom hook to detect dark mode
 * Returns 'dark' when in dark mode, undefined otherwise
 *
 * Detection strategy:
 * - Checks for vd-theme--dark class on body element (app-level dark mode)
 * - Falls back to system preference via window.matchMedia
 * - Theme detection happens once on mount and remains static
 */
export const useTheme = (): 'dark' | undefined => {
  const prefersDarkScheme =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false
  const [theme] = useState<'dark' | undefined>(() =>
    document.body.classList.contains('vd-theme--dark') || prefersDarkScheme
      ? 'dark'
      : undefined
  )

  return theme
}
